import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { useContext } from "react";
import { ContentContext } from "./../../../registration/ContentContext";
import { BoxProps } from "@mui/material";

const Container = styled(
    Box,
    {
        shouldForwardProp(prop): boolean {
            return prop !== "fullWidth";
        },
    }
)<{ fullWidth?: boolean }>(({ theme, fullWidth }) => ({
    display: "grid",
    gridTemplateColumns: `${theme.typography.pxToRem(140)} ${theme.typography.pxToRem(431)}`,
    gap: theme.spacing(4.5),
    textAlign: "left",
    marginTop: theme.spacing(3),

    ...(
        fullWidth && {
            gridTemplateColumns: `${theme.typography.pxToRem(200)} ${theme.typography.pxToRem(308)}`,
            [theme.breakpoints.down(theme.breakpoints.values.md)]: {
                gridTemplateColumns: `${theme.typography.pxToRem(160)} ${theme.typography.pxToRem(290)} auto`,
            },
        }
    ),
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        display: "block",
        marginTop: theme.spacing(2),
    },
}));

/**
 * a container that sets it grid dimensions by context
 */
export function SmartContainer(props: BoxProps) {
    const contentContext = useContext(ContentContext) || { fullWidth: true };

    return <Container {...props} fullWidth={contentContext.fullWidth} />;
}

export default SmartContainer;
